import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cls = 'w-full bg-slate-800 border border-slate-700 rounded px-3 py-2 text-sm focus:border-orange-500 outline-none';

export default function SignupReferralFields({ value, onChange }) {
  const { code, gstin, rci } = value;
  const [check, setCheck] = useState({ state: 'idle' });

  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref && !code) onChange({ ...value, code: ref.toUpperCase() });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const c = code.trim();
    if (c.length < 6) { setCheck({ state: 'idle' }); return undefined; }
    setCheck({ state: 'checking' });
    const t = setTimeout(() => {
      axios.get(`${API}/public/referral-codes/${encodeURIComponent(c)}`)
        .then((r) => setCheck({ state: 'ok', name: r.data.referrer_clinic_name }))
        .catch(() => setCheck({ state: 'bad' }));
    }, 400);
    return () => clearTimeout(t);
  }, [code]);

  const set = (k) => (e) => onChange({ ...value, [k]: k === 'code' ? e.target.value.toUpperCase() : e.target.value });
  return (
    <div className="space-y-3 border-t border-slate-800 pt-3" data-testid="signup-referral-block">
      <label className="block">
        <span className="block text-[11px] font-semibold text-slate-300 mb-1">Referral code (optional)</span>
        <input value={code} onChange={set('code')} placeholder="AUDX-XXXX00" data-testid="signup-referral-code" className={`${cls} font-mono uppercase`} />
        {check.state === 'checking' && <span className="text-[11px] text-slate-400" data-testid="signup-referral-checking">Checking code…</span>}
        {check.state === 'ok' && <span className="text-[11px] text-emerald-400 font-semibold" data-testid="signup-referral-valid">Referred by {check.name}</span>}
        {check.state === 'bad' && <span className="text-[11px] text-rose-400" data-testid="signup-referral-invalid">This referral code is not valid</span>}
      </label>
      <div className="grid grid-cols-2 gap-3">
        <label className="block">
          <span className="block text-[11px] font-semibold text-slate-300 mb-1">GSTIN (optional)</span>
          <input value={gstin} onChange={set('gstin')} placeholder="29ABCDE1234F1Z5" data-testid="signup-gstin" className={`${cls} uppercase`} />
        </label>
        <label className="block">
          <span className="block text-[11px] font-semibold text-slate-300 mb-1">RCI reg. no. (optional)</span>
          <input value={rci} onChange={set('rci')} placeholder="A12345" data-testid="signup-rci" className={`${cls} uppercase`} />
        </label>
      </div>
    </div>
  );
}
